import { render, staticRenderFns } from "./BreadcrumbRouterLink.vue?vue&type=template&id=0e803eb4"
import script from "./BreadcrumbRouterLink.vue?vue&type=script&lang=js"
export * from "./BreadcrumbRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports